<div
  aria-labelledby="ac-modalCease-label"
  class="reveal-modal"
  data-reveal
  id="{{ idModal }}"
  [attr.data-cy]="dataCy"
  role="dialog"
>
  <div class="rs-modal-heading">
    <h2 class="rs-modal-heading-title" id="ac-modalCease-label">{{ title }}</h2>
  </div>
  <div [innerHTML]="content"></div>
  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-order-m2">
        <button
          class="rs-btn rs-btn-nl-so close-reveal-modal"
          aria-haspopup="true"
          (click)="confirmClick()"
        >
          {{ confirmCTAName }}
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal">
          {{ cancelCTAName }}
        </button>
      </div>
    </div>
  </div>
</div>
